var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5402_1980)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5402_1980",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00131 12.8331C7.7675 12.834 8.52633 12.6836 9.23419 12.3904C9.94206 12.0972 10.585 11.667 11.1261 11.1245C11.6685 10.5834 12.0988 9.94047 12.392 9.23261C12.6852 8.52474 12.8356 7.76591 12.8346 6.99972C12.8356 6.23353 12.6852 5.47471 12.392 4.76684C12.0987 4.05898 11.6685 3.41604 11.1261 2.87497C10.585 2.33248 9.94206 1.90226 9.23419 1.60904C8.52633 1.31583 7.7675 1.16539 7.00131 1.16639C6.23512 1.16541 5.47629 1.31585 4.76843 1.60907C4.06057 1.90228 3.41763 2.33249 2.87656 2.87497C2.33408 3.41604 1.90387 4.05898 1.61065 4.76684C1.31744 5.47471 1.167 6.23353 1.16797 6.99972C1.16698 7.76591 1.31742 8.52474 1.61063 9.23261C1.90385 9.94047 2.33406 10.5834 2.87656 11.1245C3.41763 11.6669 4.06057 12.0972 4.76843 12.3904C5.47629 12.6836 6.23512 12.834 7.00131 12.8331Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5402_1980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.000244141H14V13.9998H0V-0.000244141Z",
    fill: "url(#paint0_linear_5402_1980)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 6.99976L6.41797 8.74976L9.91797 5.24976",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5402_1980",
    x1: 7,
    y1: -0.000244141,
    x2: 7,
    y2: 13.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22F777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37B70A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5402_1980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyGreenTick);
export default __webpack_public_path__ + "static/media/daily_green_tick.f73724b194f26864124a304167bb66d6.svg";
export { ForwardRef as ReactComponent };